export default __webpack_public_path__ + "static/media/student_contest.a79cd4e7.jpg";